/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://z2i4gwuh4ba3rf3vayurxvpgpe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-rbarbtccdfffxkkf2whzoyqf5m",
    "aws_cognito_identity_pool_id": "us-east-1:bf87a953-0004-4c9a-93d3-fc89c9a6a9a4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_GIVEynxEO",
    "aws_user_pools_web_client_id": "oh1i0aamf5p0kiban80e07l8t",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
